export default "__VITE_ASSET__Dge2wo4K__"